export enum UserRolesPersian {
  Admin = "ادمین",
  UserReal = "کاربر حقیقی",
  UserLegal = "کاربر حقوقی",
  MainLocationGuildRoomManager = "مدیر اصناف کشوری",
  ProvinceGuildRoomManager = "مدیر اتاق اصناف استان",
  CountyGuildRoomManager = "مدیر اتاق اصناف شهرستان",
  UnionManager = "مدیر اتحادیه",
  UnionIssuingManager = "مدیر صدور اتحادیه",
  UnionIssuingResponsible = "مسئول صدور اتحادیه",
  UnionSecretariat = "دبیرخانه اتحادیه",
  UnionExpert = "کارشناس اتحادیه",
  UnionJahadExpert = "کارشناس جهاد اتحادیه",
  UnionTreasurer = "خزانه دار اتحادیه",
  ProvinceSecretariat = "دبیرخانه اتاق اصناف استان",
  ProvinceTreasurer = "خزانه دار اتاق اصناف استان",
  CountySecretariat = "دبیرخانه اتاق اصناف شهرستان",
  CountyTreasurer = "خزانه دار اتاق اصناف شهرستان",
  MainLocationSecretariat = "دبیرخانه اتاق اصناف کشور",
  MainLocationTreasurer = "خزانه دار اتاق اصناف کشور",
  MainLocationGuildRoomViceManager = "نایب رئیس اتاق اصناف کشور",
  MainLocationGUildRoomExecutiveManager = "مدیر اجرایی اتاق اصناف کشور",
  ProvinceGuildRoomAdmin = "ادمین اتاق اصناف استان",
  ProvinceGuildRoomViceManager = "نایب رئیس اتاق اصناف استان",
  ProvinceGuildRoomExecutiveManager = "مدیر اجرایی اتاق اصناف استان",
  CountyGuildRoomAdmin = "ادمین اتاق اصناف شهرستان",
  CountyGuildRoomViceManager = "نایب رئیس اتاق اصناف شهرستان",
  CountyGuildRoomExecutiveManager = "مدیر اجرایی اتاق اصناف شهرستان",
  UnionAdmin = "ادمین اتحادیه",
  UnionViceManager = "نایب رئیس اتحادیه",
  UnionViceExecutiveManager = "مدیر اجرایی اتحادیه",
  ITManger = "فناوری اطلاعات کشور",
  JahadCenterExpert = "کارشناس جهاد",
  JahadCenterManager = "مدیر جهاد"
}
